import rangePicker from './range-picker'
import datePicker from './date-picker'
export default { datePicker, rangePicker }
